<div fxLayout="column" fxLayoutGap="15px" fxFlex="100">
  <div fxLayout="row">
    <h3>Wynik</h3>
  </div>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Wyrejestrowane" [value]="registrationIdImport.result.deregistered.toString()"></app-detail>
  <app-detail *ngIf="registrationIdImport.shippingReport" fxFlex="100" header="Identyfikatory nie wysłane" [value]="registrationIdImport.result.deregistered.toString()"></app-detail>


  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Wyrejestrowane PESEL">
    <ng-container *ngFor="let pesel of registrationIdImport.result?.deregisteredPesel; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>
  <app-detail *ngIf="registrationIdImport.shippingReport" fxFlex="100" header="OFWCE bez regionalnego">
    <ng-container *ngFor="let pesel of registrationIdImport.result?.deregisteredPesel; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>
  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Nieznalezione PESEL">
    <ng-container *ngFor="let pesel of registrationIdImport.result.notFoundPesel; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Nieznalezione RAU">
    <ng-container *ngFor="let rau of registrationIdImport.result.notFoundRau; let last = last">
      {{rau}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Nieznalezione rejestracje">
    <ng-container *ngFor="let pesel of registrationIdImport.result.notFoundRegistration; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Duplikaty PESEL">
    <ng-container *ngFor="let pesel of registrationIdImport.result.duplicatedPesel; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Duplikaty RAU">
    <ng-container *ngFor="let rau of registrationIdImport.result.duplicatedRau; let last = last">
      {{rau}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>

  <app-detail *ngIf="!registrationIdImport.shippingReport" fxFlex="100" header="Duplikaty rejestracji">
    <ng-container *ngFor="let pesel of registrationIdImport.result.duplicatedRegistration; let last = last">
      {{pesel}}<ng-container *ngIf="!last">, </ng-container>
    </ng-container>
  </app-detail>
</div>
